import React from 'react';

import { ClampBox, ClampRoot, ClampToggle } from './styles';

type ClampedTextProps = {
  children: React.ReactNode;
  lines?: number;
  whiteSpace?: 'normal' | 'pre-line' | 'pre-wrap';
};

const ClampedText: React.FC<ClampedTextProps> = ({ children, lines = 3, whiteSpace = 'pre-line' }) => {
  const [expanded, setExpanded] = React.useState(false);
  const [overflows, setOverflows] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    if (ref.current && !expanded) {
      setOverflows(ref.current.scrollHeight > ref.current.clientHeight);
    }
  });

  return (
    <ClampRoot>
      <ClampBox ref={ref} $expanded={expanded} $lines={lines} $whiteSpace={whiteSpace}>
        {children}
      </ClampBox>
      {(overflows || expanded) && (
        <ClampToggle size="small" variant="text" onClick={(): void => setExpanded((value) => !value)}>
          {expanded ? 'View less...' : 'View more...'}
        </ClampToggle>
      )}
    </ClampRoot>
  );
};

export default ClampedText;
